import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Popup.css";

function Header({ isAuthenticated }) {
  const [showPopup, setShowPopup] = useState(false);
  const [showArchives, setShowArchives] = useState(false);
  const [expandedYears, setExpandedYears] = useState({});
  const [popupMessage, setPopupMessage] = useState(null); // 🔧 Track selected message
  const flyoutRef = useRef(null);

  const closeArchives = () => setShowArchives(false);

  const messages = [
    {
      heading: "✓ You Did It",
      lines: [
        "Somewhere, Will just high-fived himself in a mirror. Twice.",
        "☞ Bonus: You're now legally 3% more mysterious than you were five minutes ago.",
        "✎ Look for our upcoming exposé: “He Brought Tupperware to a Deposition”",
      ],
    },
    {
      heading: "✓ Subscription Confirmed",
      lines: [
        "Your inbox is now eligible for at least one confusing Will-related update per month.",
        '☞ Bonus: You’re officially part of our elite "No Cheesecake, No Peace" club.',
        "✎ Coming soon: “I Thought It Was Compost” – A Legal Memoir",
      ],
    },
    {
      heading: "✓ Welcome, Brave Soul",
      lines: [
        "You’re now closer to understanding Will’s apology note filing system. (Spoiler: he uses soup cans.)",
        "☞ Bonus: One of you will be randomly selected to receive a passive-aggressive pumpkin bar.",
        "✎ Upcoming story drop: “He Swore the Creek Was Navigable”",
      ],
    },
    {
      heading: "✓ You’ve Joined the Chaos",
      lines: [
        "That sound you hear? Will trying to fax a pan of cheesecake.",
        "☞ Bonus: You now have exclusive access to updates no one asked for—but everyone reads.",
        "✎ Sneak peek: “100 Apologies and a Muffin” – A Redemption Saga",
      ],
    },
    {
      heading: "✓ Subscription Success",
      lines: [
        "You’re now 1.7% more informed than Will is on any given day.",
        "☞ Bonus: This unlocks nothing, but it feels good, doesn’t it?",
        "✎ Upcoming release: “Exhibit B: The Cheesecake That Never Came”",
      ],
    },
  ];

  const handleSubscribe = () => {
    // 🔧 Pick a random message each time
    const randomIndex = Math.floor(Math.random() * messages.length);
    setPopupMessage(messages[randomIndex]);
    setShowPopup(true);
  };

  const toggleYear = (year) => {
    setExpandedYears((prev) => ({
      ...prev,
      [year]: !prev[year],
    }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (flyoutRef.current && !flyoutRef.current.contains(event.target)) {
        setShowArchives(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  return (
    <div
      style={{
        background: "#152543",
        fontFamily: "Roboto",
        height: "35px",
        display: "flex",
        padding: "15px",
        alignItems: "center",
        position: "relative",
      }}
    >
      <div
        style={{
          flex: 1,
          color: "white",
          fontWeight: 600,
          fontSize: "30px",
          display: "flex",
        }}
      >
        {isAuthenticated ? (
          <Link className="header-link" to="/">
            FLAT News
          </Link>
        ) : (
          "FLAT News"
        )}
      </div>

      {/* ARCHIVES */}
      {isAuthenticated && (
        <div className="archives-wrapper" ref={flyoutRef}>
          <button
            className="more-button"
            onClick={() => setShowArchives((prev) => !prev)}
            aria-label="More"
          >
            ⋮
          </button>

          {showArchives && (
            <div className="archives-flyout dark-theme">
              <div className="tree-header">Archived Articles</div>

              <div className="tree-node">
                {/* <Link to="half-birthday">Happy Half Birthday!</Link> */}
                {<Link to="birthday-clue">Happy Birthday!</Link>}
                <div className="tree-toggle" onClick={() => toggleYear("2025")}>
                  {expandedYears["2025"] ? "▼" : "▶"} 2025
                </div>
                {expandedYears["2025"] && (
                  <div className="tree-children">
                    <Link to="/hike" onClick={closeArchives}>
                      Alpine Mayhem: Illinois Tourist Disrupts Swiss Serenity
                      With Loud Hiking, Louder Opinions
                    </Link>
                    <Link to="/waitress" onClick={closeArchives}>
                      Feucht Fellowship or Friendly Filibuster? Church Lunches
                      Run Long
                    </Link>
                    <Link to="/gondola" onClick={closeArchives}>
                      Gondola Gourmet? Illinois Man Causes Chaos in Venice After
                      Donning Chef’s Hat Mid-Selfie
                    </Link>
                    <Link to="/trial" onClick={closeArchives}>
                      HORROR AT COURT: A courtroom reckoning with the darkest
                      corners of humanity: the fight for justice begins
                    </Link>
                    <Link to="/ski" onClick={closeArchives}>
                      Lake Odessa Braces for Another Weekend of Feucht and Fury
                    </Link>
                    <Link to="/nuns" onClick={closeArchives}>
                      Nuns Rattled But Resilient After American Tourist Launches
                      Surprise Group Selfie at Convent Garden
                    </Link>
                    <Link to="/cathedral" onClick={closeArchives}>
                      Selfie Showdown at Strasbourg Cathedral as Illinois Man
                      Photobombs 37 Tours in One Afternoon
                    </Link>
                    <Link to="/road" onClick={closeArchives}>
                      Tour de Feucht: One Man’s Journey to Inconvenience Us All
                    </Link>
                    {/* <Link to="/birthday" onClick={closeArchives}>
                      Buc-ee Birthday Wishes
                    </Link> */}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}

      {/* SUBSCRIBE BUTTON */}
      {isAuthenticated && (
        <button
          style={{
            color: "white",
            background: "#C00000",
            outline: "none",
            border: "none",
            fontSize: "18px",
            height: "35px",
            padding: "0px 15px",
            cursor: "pointer",
            borderRadius: "4px",
            marginLeft: "10px",
          }}
          onClick={handleSubscribe}
        >
          Subscribe
        </button>
      )}

      {/* SUBSCRIBE POPUP */}
      {isAuthenticated && showPopup && popupMessage && (
        <div className="popup-container">
          <div className="popup">
            <button
              className="popup-close-icon"
              onClick={() => setShowPopup(false)}
              aria-label="Close popup"
            >
              &times;
            </button>
            <h2>{popupMessage.heading}</h2>
            {popupMessage.lines.map((line, index) => (
              <p key={index}>{line}</p>
            ))}
            <button
              onClick={() => setShowPopup(false)}
              className="close-button"
            >
              Unsubscribe While You Still Can
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Header;
